<template>
  <div id="app" >
    <!--<img src="./assets/logo.png">
    <div>
     build 原打包码没地方放放这边 "rimraf dist && webpack -p --progress --hide-modules"
      <el-button @click="startHacking">Start</el-button>
    </div>-->

    <router-link to="/home"></router-link>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    startHacking () {
      this.$notify({
        title: 'It works!',
        type: 'success',
        message: 'We\'ve laid the ground work for you. It\'s time for you to build something epic!',
        duration: 5000
      })
    }
  }
}
</script>

<style>
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue